import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ArrowLeft, Bell } from 'lucide-react';
import Logo from './Logo';
import { useApp } from '../context/AppContext';

export function useLocalState(key, initial) {
  const [v, setV] = React.useState(() => { try { const s = localStorage.getItem(`clax:${key}`); return s ? JSON.parse(s) : initial; } catch { return initial; } });
  React.useEffect(() => { localStorage.setItem(`clax:${key}`, JSON.stringify(v)); }, [key, v]);
  return [v, setV];
}

export default function PortalShell({ label, nav, children, accent = '#8B2CFF', title, actions }) {
  const { user } = useApp();
  return (
    <div className="min-h-screen bg-[#0B0A0E] text-[#FFFFFF] flex flex-col" data-testid={`portal-${label.toLowerCase()}`}>
      <header className="h-[60px] flex items-center px-5 border-b border-[#221D2B] bg-[#15121B] sticky top-0 z-40">
        <Link to="/" className="flex items-center gap-3"><Logo height={34} /><span className="text-[11px] font-bold tracking-[0.2em] uppercase px-2 py-1 rounded-md" style={{ background: `${accent}26`, color: accent }}>{label}</span></Link>
        <div className="ml-auto flex items-center gap-5">
          <Link to="/" className="text-[12.5px] text-[#C7C4CB] hover:text-[#FFFFFF] flex items-center gap-1.5"><ArrowLeft size={14} /> Back to Clax</Link>
          <button className="text-[#C7C4CB] hover:text-[#FFFFFF]"><Bell size={18} /></button>
          <div className="flex items-center gap-2"><img src={user?.avatar} alt="" className="w-8 h-8 rounded-full object-cover" /><span className="text-[13px] hidden md:inline">{user?.name}</span></div>
        </div>
      </header>
      <div className="flex flex-1">
        <aside className="w-[220px] flex-none border-r border-[#221D2B] p-3 hidden md:block sticky top-[60px] self-start h-[calc(100vh-60px)]">
          {nav.map(({ to, label: l, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `flex items-center gap-3 h-10 px-3 rounded-lg text-[13.5px] mb-1 transition-colors ${isActive ? 'bg-[#2A1C45] text-[#FFFFFF] font-medium' : 'text-[#C7C4CB] hover:bg-white/[0.04] hover:text-[#FFFFFF]'}`} data-testid={`portal-nav-${l.toLowerCase().replace(/\s+/g, '-')}`}>
              {({ isActive }) => (<><Icon size={17} style={isActive ? { color: accent } : undefined} />{l}</>)}
            </NavLink>
          ))}
        </aside>
        <main className="flex-1 min-w-0 p-6 lg:p-8">
          {(title || actions) && <div className="flex flex-wrap items-center justify-between gap-3 mb-6"><h1 className="text-[24px] font-bold tracking-tight">{title}</h1><div className="flex gap-2">{actions}</div></div>}
          {children}
        </main>
      </div>
    </div>
  );
}
